export default __webpack_public_path__ + "static/media/Calendario-orange.818cb5db.svg";